var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 4.46154H15.75V3H14.3333V4.46154H8.66667V3H7.25V4.46154H4.41667C3.6375 4.46154 3 5.11923 3 5.92308V20.5385C3 21.3423 3.6375 22 4.41667 22H18.5833C19.3625 22 20 21.3423 20 20.5385V5.92308C20 5.11923 19.3625 4.46154 18.5833 4.46154ZM18.5833 20.5385H4.41667V10.3077H18.5833V20.5385ZM18.5833 8.84615H4.41667V5.92308H7.25V7.38462H8.66667V5.92308H14.3333V7.38462H15.75V5.92308H18.5833V8.84615Z",
    fill: "none",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15L11 17L15 13",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservations);
export default __webpack_public_path__ + "static/media/reservations.7a1ffcdab348a5e3c6a9fc388b1b1df8.svg";
export { ForwardRef as ReactComponent };